import { toggle } from "@otto-ec/global-resources/toggle";
import { onReady } from "@otto-ec/global-resources/dom";

if(toggle.get("fti_enable_session_refresh_by_session_maintenance")) {
  onReady.subscribe(async () => {
      await fetch("/session-maintenance/refresh");
  })
}
